import { useState, useEffect } from "react";
import { getContracts } from "@/services";

const useGetContracts = () => {
  const [data, setData] = useState(null);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    const doRequest = async () => {
      setIsLoading(true);

      const response = await getContracts();

      setData(response);

      setIsLoading(false);
    };

    doRequest();
  }, []);

  return { data, isLoading };
};

export { useGetContracts };
